const state = {
  status: '',
  condominium_id: '',
  condominiumName: '',
  date_init: '',
  date_end: '',
  cboTypeDocs: [],
  typesList: [],
  docTypeSel: {},
  docDetailDialogShow: false,
  completDocList: []
}

const mutations = {
  updateSearchData (state, obj) {
    if (obj.id) state.condominium_id = obj.id
    if (obj.condominiumName) state.condominiumName = obj.condominiumName
    if (obj.date_init) state.date_init = obj.date_init
    if (obj.date_end) state.date_end = obj.date_end
  },

  updateCompletDocList (state, data) {
    state.completDocList.push(data)
  },

  resetCompletDocList (state) {
    state.completDocList = []
  },

  updateCboTypeDocs (state, arr) {
    state.cboTypeDocs = []
    state.cboTypeDocs = arr
  },

  updateDocTypeSel (state, obj) {
    state.docTypeSel = { ...obj }
  },

  updateDialogShow (state, show) {
    state.docDetailDialogShow = show
  },

  updateTypeDocsList (state, arr) {
    state.typesList = arr
  }
}

const actions = {
  openDocDetailDialog () {
    this.commit('docsReports/updateDialogShow', true)
  },

  closeDocDetailDialog () {
    this.commit('docsReports/updateDialogShow', false)
  },

  getDocDetails (state) {
    // console.log(state)
    let query = {
      status: this.state.docsReports.docTypeSel.status,
      condominium_id: this.state.docsReports.condominium_id,
      date_init: this.state.docsReports.date_init,
      date_end: this.state.docsReports.date_end,
      type_id: this.state.docsReports.docTypeSel.type_id,
      type_doc: this.state.docsReports.docTypeSel.type_id ? 2 : 1
    }

    let obj = {
      url: '/api/listReportsDoc',
      query: query,
      method: 'post'
    }

    this.dispatch('request/doRequest', obj).then(response => {
      // let arr = { ...response.data };
      // console.log(arr)
      this.commit('docsReports/updateTypeDocsList', response.data)
    })
  },

  resetCompletDocList () {
    this.commit('docsReports/resetCompletDocList')
  },

  getDocDetailsFromCompletList (state, docName) {
    // console.log(state)
    let query = {
      status: this.state.docsReports.docTypeSel.status,
      condominium_id: this.state.docsReports.condominium_id,
      date_init: this.state.docsReports.date_init,
      date_end: this.state.docsReports.date_end,
      type_id: this.state.docsReports.docTypeSel.type_id,
      type_doc: this.state.docsReports.docTypeSel.type_id ? 2 : 1
    }

    let obj = {
      url: '/api/listReportsDoc',
      query: query,
      method: 'post'
    }

    this.dispatch('request/doRequest', obj).then(response => {
      // let arr = { ...response.data };
      // console.log(arr)
      let obj = {}
      obj.arr = response.data
      obj.name = docName
      this.commit('docsReports/updateCompletDocList', obj)
    })
  }
}

export default {
  namespaced: true,
  root: true,
  actions,
  mutations,
  state
}
